import { Link } from 'react-router';
import type { RoutingStatus } from '@mcpanel/core';
export function EdgeIpWarning({ edge }: { edge?: RoutingStatus['edge'] }) {
  if (!edge?.ipChanged) return null;
  return (
    <div className="alert danger" role="alert">
      <strong>未反映（IP が変わった）</strong>：{edge.changedServers?.join('、')}。
      <Link to="/routing">接続先の「edge に反映」</Link>で新しい IP を配ってください。
    </div>
  );
}
